const defaultProps = {
  center: {
    lat: 37.0902,
    lng: -95.7129,
  },
  zoom: 4,
  id: "product-finder",
  googleMapsApiKey: process.env.GHUB_GOOGLE_PLACES_API_KEY,
};

// you can override any of the default props from above with opts object
export const getDefaultProps = (opts = {}) => {
  // console.log(defaultProps)
  // console.log(opts)
  // Object.assign(defaultProps, opts);
  // return defaultProps

  return opts
};

export const createKey = (location) => {
  // console.log(location)
  return location.content.id;
};

export const getLocationId = (url) => {
  return url.split('/')[2]
};

export const openInNewTab = (url) => {
  // 👇️ setting target to _blank with window.open
  window.open(url, "_blank");
};